"use client";

import React from "react";
import Image from "next/image";
import "./NbPalmTerraceSection.css";
import { motion } from "framer-motion";
export default function NbPalmTerraceSection({ projectDetail }) {
  const isNbPalm = String(projectDetail?.project_id) === "880";
  const scaleFadeVariant = {
    hidden: {
      opacity: 0,
      scale: 0.95,
    },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.8,
        ease: "easeOut",
      },
    },
  };
  if (!isNbPalm) return null;

  return (
    <section className="nb-terrace-section section-padding">
      <div className="main-container-fluid">
        <div className="nb-terrace-grid">
          {/* IMAGE */}

          <motion.div
            className="nb-terrace-image"
            variants={scaleFadeVariant}
            initial="hidden"
            whileInView="visible"
            viewport={{
              once: true,
              amount: 0.3,
            }}
          >
            <div className="nb-terrace-image-wrap">
              <Image
                fill
                priority
                src="/images/nb-palm/terrace-living.jpg"
                alt="NB Palm Terrace"
                className="object-cover"
                sizes="
                (max-width:991px)
                100vw,
                65vw
                "
              />
            </div>
          </motion.div>

          {/* CONTENT */}

          <motion.div
            className="section-paragraph content-teeerr"
            variants={scaleFadeVariant}
            initial="hidden"
            whileInView="visible"
            viewport={{
              once: true,
              amount: 0.3,
            }}
          >
            <p>
              Here, at the uppermost levels of NB Palm, the boundary between
              inside and outside gently disappears. Open-air terraces frame the
              sky, welcome natural light, and offer panoramic views, defined by
              expansive layouts. Every element enhances privacy, openness, and a
              heightened sense of living above the everyday.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
